import { Injectable } from '@angular/core';
import {
    SourceCodeExcludeRepoService,
} from '@client/app/services/api/source-code-exclude-repo/source-code-exclude-repo.service';
import {
    SourceCodeExcludesEntityService,
} from '@client/app/services/entities/source-code-excludes/source-code-excludes.service';
import {
    AccessibilitySourceCodeExcludeRepoService,
} from '@client/app/services/api/accessibility-source-code-exclude-repo.service';
import {
    AccessibilitySourceCodeExcludesService,
} from '@client/app/services/entities/accessibility/source-code-excludes/source-code-excludes.service';

/**
 * Source Code Excludes Service
 * @description Source Code Excludes Service
 */
@Injectable({
    providedIn: 'root',
})
export class SourceCodeExcludesApiService {
    constructor (
        private accessibilitySourceCodeExcludesEntity: AccessibilitySourceCodeExcludesService,
        private accessibilitySourceCodeExcludeRepo: AccessibilitySourceCodeExcludeRepoService,
        private sourceCodeExcludesEntity: SourceCodeExcludesEntityService,
        private sourceCodeExcludeRepo: SourceCodeExcludeRepoService,
    ) {}

    getAll (module: string, params?: any, config?: any): any {
        if (module === 'accessibility') {
            return this.getAccessibilitySourceCodeExcludes(params, config);
        } else {
            return this.getSourceCodeExcludes(module, params, config);
        }
    }

    get (module: string, sourceCodeExclude: any, params?: any, config?: any): any {
        if (module === 'accessibility') {
            return this.getAccessibilitySourceCodeExclude(sourceCodeExclude, params, config);
        } else {
            return this.getSourceCodeExclude(module, sourceCodeExclude, params, config);
        }
    }

    create (module: string, sourceCodeExclude: any, params?: any, config?: any): any {
        if (module === 'accessibility') {
            return this.createAccessibilitySourceCodeExclude(sourceCodeExclude, params, config);
        } else {
            return this.createSourceCodeExclude(sourceCodeExclude, params, config);
        }
    }

    update (module: string, sourceCodeExclude: any, updatedSourceCodeExclude: any, params?: any, config?: any): any {
        if (module === 'accessibility') {
            return this.updateAccessibilitySourceCodeExclude(
                sourceCodeExclude,
                updatedSourceCodeExclude,
                params,
                config,
            );
        } else {
            return this.updateSourceCodeExclude(sourceCodeExclude, updatedSourceCodeExclude, params, config);
        }
    }

    destroy (module: string, sourceCodeExclude: any, params?: any, config?: any): any {
        if (module === 'accessibility') {
            return this.destroyAccessibilitySourceCodeExcludes(sourceCodeExclude, params, config);
        } else {
            return this.destroySourceCodeExcludes(sourceCodeExclude, params, config);
        }
    }

    // PROTECTED

    private getAccessibilitySourceCodeExcludes (params?: any, config?: any): any {
        return this.accessibilitySourceCodeExcludeRepo.getAll(params, config);
    }

    private getSourceCodeExcludes (module: string, params?: any, config?: any): any {
        params = params || {};
        params.module = module;
        return this.sourceCodeExcludeRepo.getAll(params, config);
    }

    private getAccessibilitySourceCodeExclude (sourceCodeExclude: any, params?: any, config?: any): any {
        return this.accessibilitySourceCodeExcludeRepo.get(sourceCodeExclude.id, params, config);
    }

    private getSourceCodeExclude (module: string, sourceCodeExclude: any, params?: any, config?: any): any {
        params = params || {};
        params.module = module;
        return this.sourceCodeExcludeRepo.get(sourceCodeExclude.id, params, config);
    }

    private createSourceCodeExclude (sourceCodeExclude: any, params?: any, config?: any): any {
        return this.sourceCodeExcludesEntity.create(sourceCodeExclude, params, config);
    }

    private createAccessibilitySourceCodeExclude (sourceCodeExclude: any, params?: any, config?: any): any {
        return this.accessibilitySourceCodeExcludeRepo.create(sourceCodeExclude, params, config);
    }

    private updateSourceCodeExclude (sourceCodeExclude: any, updatedSourceCodeExclude: any, params?: any, config?: any): any {
        return this.sourceCodeExcludesEntity.update(sourceCodeExclude, updatedSourceCodeExclude, params, config);
    }

    private updateAccessibilitySourceCodeExclude (sourceCodeExclude: any, updatedSourceCodeExclude: any, params?: any, config?: any): any {
        return this.accessibilitySourceCodeExcludesEntity.update(
            sourceCodeExclude,
            updatedSourceCodeExclude,
            params,
            config,
        );
    }

    private destroySourceCodeExcludes (sourceCodeExclude: any, params?: any, config?: any): any {
        return this.sourceCodeExcludesEntity.destroy(sourceCodeExclude, params, config);
    }

    private destroyAccessibilitySourceCodeExcludes (sourceCodeExclude: any, params?: any, config?: any): any {
        return this.accessibilitySourceCodeExcludesEntity.destroy(sourceCodeExclude, params, config);
    }
}
